// Hide for tax total in cart
(function() {
  // First, wait for the spark-drawer element itself
  const drawerObserver = new MutationObserver(() => {
    const drawer = document.querySelector('spark-drawer');
    if (drawer) {
      drawerObserver.disconnect();
      
      // Wait for shadowRoot to be attached
      const checkShadow = setInterval(() => {
        if (drawer.shadowRoot) {
          clearInterval(checkShadow);
          
          // Now observe changes INSIDE the shadow DOM
          const shadowObserver = new MutationObserver(() => {
            const target = drawer.shadowRoot.querySelector('.space-y-2 > .flex:nth-child(3)');
            if (target) {
              target.style.display = 'none';
              // Keep observing in case content re-renders
            }
          });
          
          shadowObserver.observe(drawer.shadowRoot, { 
            childList: true, 
            subtree: true 
          });
          
          // Also try to hide immediately if already rendered
          const target = drawer.shadowRoot.querySelector('.space-y-2 > .flex:nth-child(3)');
          if (target) {
            target.style.display = 'none';
          }
        }
      }, 100);
    }
  });
  
  drawerObserver.observe(document.body, { childList: true, subtree: true });
})();


// Reposition stock status from shadow DOM to outside the card-information__wrapper (Backorder text fix)
document.addEventListener('DOMContentLoaded', function (event) {
  // Add global CSS to hide stock status in shadow DOM immediately
  const globalStyle = document.createElement('style');
  globalStyle.textContent = `
    spark-product-card .product-card-stock-status {
      display: none !important;
    }
  `;
  document.head.appendChild(globalStyle);

  // Function to clean up stock status text
  function cleanStockStatusText(content) {
    if (!content) return '';

    // Check if the content contains "Due: DD/MM/YYYY" pattern
    const datePattern = /Due:\s*\d{1,2}\/\d{1,2}\/\d{4}/i;

    // If no "Due:" date is found, remove "(Estimated Date)" text
    if (!datePattern.test(content)) {
      content = content.replace(/\s*\(Estimated Date\)/gi, '');
    }

    return content.trim();
  }

  function repositionStockStatus() {
    // Find all spark-product-card elements
    const productCards = document.querySelectorAll('spark-product-card');
    let processed = 0;

    // check if there any product cards and only run if at least 1 exists
    if (productCards.length === 0) {
      console.log('No product cards found to reposition stock status.');
      return;
    }

    productCards.forEach(card => {
      // Access the shadow root
      if (!card.shadowRoot) return;

      // Find the stock status element inside the shadow DOM
      const stockStatus = card.shadowRoot.querySelector('.product-card-stock-status');
      if (!stockStatus) return;

      // Check if we've already processed this card
      if (card.hasAttribute('data-status-repositioned')) return;
      card.setAttribute('data-status-repositioned', 'true');
      processed++;

      // Find the card-information__wrapper in the parent DOM
      const cardInfoWrapper = card.closest('.card-information').querySelector('.card-information__wrapper');
      if (!cardInfoWrapper) return;

      // Create a clone of the stock status content for the light DOM
      const stockStatusClone = document.createElement('div');
      stockStatusClone.className = 'extracted-stock-status';
      const cleanedContent = cleanStockStatusText(stockStatus.innerHTML);
      stockStatusClone.innerHTML = cleanedContent;

      // Insert the clone before the card info wrapper
      cardInfoWrapper.parentNode.insertBefore(stockStatusClone, cardInfoWrapper);

      // Hide the original stock status in the shadow DOM immediately and with CSS
      stockStatus.style.display = 'none';
      const styleTag = document.createElement('style');
      styleTag.textContent = '.product-card-stock-status { display: none !important; }';
      card.shadowRoot.appendChild(styleTag);

      // Set up a MutationObserver to watch for changes in the shadow DOM stock status
      const shadowObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            // Check if the stock status element still exists and has content
            const currentStockStatus = card.shadowRoot.querySelector('.product-card-stock-status');
            let newContent = '';

            if (currentStockStatus && currentStockStatus.innerHTML) {
              newContent = cleanStockStatusText(currentStockStatus.innerHTML);
            }

            // If content is empty or just whitespace, hide the clone
            if (!newContent || newContent === '') {
              stockStatusClone.style.display = 'none';
            } else {
              stockStatusClone.innerHTML = newContent;
              stockStatusClone.style.display = 'block';
            }

            // Re-apply hiding to any stock status elements found
            const allStockStatus = card.shadowRoot.querySelectorAll('.product-card-stock-status');
            allStockStatus.forEach(element => {
              element.style.display = 'none';
            });
          }
        });
      });

      // Start observing the entire shadow root instead of just the stock status element
      shadowObserver.observe(card.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });

      // Also observe the entire shadow root for new stock status elements
      const shadowRootObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            // Handle removed nodes (when stock status is completely removed)
            mutation.removedNodes.forEach(function (node) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const removedStockStatus = node.classList && node.classList.contains('product-card-stock-status')
                  ? node
                  : node.querySelector && node.querySelector('.product-card-stock-status');

                if (removedStockStatus) {
                  // If stock status was removed, hide our clone
                  stockStatusClone.style.display = 'none';
                }
              }
            });

            // Handle added nodes (when stock status is recreated)
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // Check if this is a stock status element or contains one
                const newStockStatus = node.classList && node.classList.contains('product-card-stock-status')
                  ? node
                  : node.querySelector && node.querySelector('.product-card-stock-status');

                if (newStockStatus) {
                  // Hide the new stock status element
                  newStockStatus.style.display = 'none';

                  // Update our clone with new content
                  const newContent = cleanStockStatusText(newStockStatus.innerHTML);

                  // If content is empty or just whitespace, hide the clone
                  if (!newContent || newContent === '') {
                    stockStatusClone.style.display = 'none';
                  } else {
                    stockStatusClone.innerHTML = newContent;
                    stockStatusClone.style.display = 'block';
                  }
                }
              }
            });
          }
        });
      });

      shadowRootObserver.observe(card.shadowRoot, {
        childList: true,
        subtree: true
      });

      // Store both observer references
      card._stockStatusObserver = shadowObserver;
      card._shadowRootObserver = shadowRootObserver;
    });

    //console.log(`Repositioned stock status for ${processed} products`);
  }

  // Listen for our custom event
  document.addEventListener('sparklayer:reposition-stock-status', function () {
    setTimeout(repositionStockStatus, 100);
  });

  // Initial run
  setTimeout(repositionStockStatus, 500);

  // Setup MutationObserver to watch for new product cards
  const observer = new MutationObserver(function (mutations) {
    setTimeout(repositionStockStatus, 100);
  });

  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Check periodically in case some cards load after initial DOM load
  const interval = setInterval(repositionStockStatus, 1000);
  // Stop checking after 10 seconds
  setTimeout(() => clearInterval(interval), 10000);

});